'use memo';

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ComingSoonCover from '@/components/ComingSoonCover';
import { FillScreen } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import placeholderAlerts from '../-assets/placeholder-alerts.png';
import { DEVICE_ASSIGNMENT_FEATURE_FLAG } from '../-constants/featureFlags';
import { DeviceAssignmentAlertCategorySidebar } from './-components/DeviceAssignmentAlertCategorySidebar';
import { useDeviceAssignmentAlertCountsQuery } from './-query';
import { DeviceAssignmentAlertsSearchSchema } from './-zod-schema';
const ALERTS_BASE_PATH = '/devices/alerts';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts')({
  validateSearch: zodValidator(DeviceAssignmentAlertsSearchSchema),
  // 本番非公開: FeatureFlag OFF の間は子ルート（to-be-assigned 等）の loader を走らせないよう、
  // 基点 /devices/alerts 以外の直接 URL アクセスを基点へ戻す。基点では component が
  // ComingSoonCover を表示する（index の to-be-assigned への redirect は FLAG ON 時のみ発火）。
  beforeLoad: ({
    location
  }) => {
    if (featureFlags.check(DEVICE_ASSIGNMENT_FEATURE_FLAG)) {
      return;
    }
    const path = location.pathname.replace(/\/+$/, '');
    if (path !== ALERTS_BASE_PATH) {
      throw redirect({
        to: ALERTS_BASE_PATH
      });
    }
  },
  component: RouteComponent
});
function RouteComponent() {
  // 本番非公開: FeatureFlag OFF の間は ComingSoonCover を表示し、実装へは遷移させない
  if (!featureFlags.check(DEVICE_ASSIGNMENT_FEATURE_FLAG)) {
    return <ComingSoonCover placeholderImage={placeholderAlerts} />;
  }
  return <DeviceAssignmentAlertsLayout />;
}
function DeviceAssignmentAlertsLayout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.alerts'
  });
  useDocumentTitle(t('pageTitle'));
  const countsQuery = useDeviceAssignmentAlertCountsQuery();
  return <FillScreen className="flex min-h-0 overflow-hidden">
      <DeviceAssignmentAlertCategorySidebar counts={countsQuery.data} />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </FillScreen>;
}